import styled from "styled-components";

export const VerifyStyle = styled.form`
  margin-inline: 20px;
  padding-block: 50px;
  height: calc(100vh - 110px);
`;

export const PinTextPhoneNumber = styled.span`
  color: #05be71;
`;

export const PinText = styled.div`
  margin-block-start: 20px;
`;

export const VerifyButtonWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: calc(100vw - 40px);
  max-width: calc(425px - 40px);
`;